import React from 'react';
import { Flex } from '@chakra-ui/react';
import { Modal, Button, OutlineCard } from '@morressier/alembic';

import { FormProvider, useForm } from 'react-hook-form';
import { generateValidationSchema } from 'src/utils/validation';
import { ajvResolver } from '@hookform/resolvers/ajv';
import _ from 'lodash';
import { IFormFieldText } from '.';
import FormFieldTextArea from 'src/components/FormField/FormFieldTextArea';
import { IExternalFieldDependency } from '@publishing-engine/domain/types/article';
interface IProps {
  isOpen: boolean;
  onSubmit: (value: string) => void;
  onCancel: () => void;
  formField: IFormFieldText;
  value?: string;
  externalDependency?: IExternalFieldDependency;
}

type ITextAreaFormState = {
  metadata?: {
    [key in 'title' | 'abstract' | 'noveltyStatement']: string;
  };
  preference?: {
    [key in 'acceleratedPublication' | 'ipemMembership']: string;
  };
  // | "metadata.noveltyStatement" | "preference.acceleratedPublication" | "preference.ipemMembership"
};

const TextUpdateModal: React.FC<IProps> = props => {
  const { isOpen, onSubmit, onCancel, formField, externalDependency } = props;
  let { value } = props;

  if (value === null) {
    value = '';
  }

  const schema = generateValidationSchema({
    [formField.name]: formField
  });
  const fieldName = formField.caseDataFields.main;

  const methods = useForm({
    defaultValues: _.merge(
      {} as ITextAreaFormState,
      _.set({}, formField.caseDataFields.main, props.value),
      externalDependency
        ? _.set({}, externalDependency.path, externalDependency?.value)
        : {}
    ),
    resolver: ajvResolver(schema)
  });

  const { handleSubmit } = methods;
  const updateField = {
    ...formField,
    params: {
      ...formField.params,
      labels: {
        ...formField.params.labels,
        main: `Update ${formField.params.labels.main}`
      }
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={() => {}}
      width="755px"
      closeButtonProps={{
        hidden: true
      }}
    >
      <Flex flexDirection="column" gap={8}>
        <FormProvider {...methods}>
          <form
            onSubmit={handleSubmit(data => {
              // TODO: see if we can avoid typecasting
              onSubmit(_.get(data, fieldName) as string);
            })}
          >
            <OutlineCard borderless padding={8} width="100%">
              <Flex flexDirection="column" gap={2}></Flex>
              <Flex flexDirection="column" gap={2}>
                <FormFieldTextArea config={updateField as IFormFieldText} />
                <Flex gap={2} justifyContent="flex-end">
                  <Button
                    variant="secondary"
                    onClick={onCancel}
                    borderRadius="small"
                  >
                    Exit Without Saving
                  </Button>
                  <Button variant="primary" type="submit" borderRadius="small">
                    Save Changes
                  </Button>
                </Flex>
              </Flex>
            </OutlineCard>
          </form>
        </FormProvider>
      </Flex>
    </Modal>
  );
};

export default TextUpdateModal;
